const simpleBarOverflowTolerance = 1;

export const hasSimpleBarOverflow = (scrollHeight, clientHeight) => {
  if (!Number.isFinite(scrollHeight) || !Number.isFinite(clientHeight)) {
    return false;
  }

  return scrollHeight - clientHeight > simpleBarOverflowTolerance;
};
